import React, { useState, useEffect } from "react";

export default function SequenceGame() {
    const [sequence, setSequence] = useState([]);
    const [userSeq, setUserSeq] = useState([]);
    const [showing, setShowing] = useState(false);
    const [level, setLevel] = useState(1);
    const [gameOver, setGameOver] = useState(false);
    const [started, setStarted] = useState(false);

    const colors = ["#ef4444", "#22c55e", "#3b82f6", "#facc15"];

    const startGame = () => {
        setStarted(true);
        setLevel(1);
        setGameOver(false);
        setUserSeq([]);
        nextRound();
    };

    const nextRound = () => {
        const newSeq = [...sequence, Math.floor(Math.random() * 4)];
        setSequence(newSeq);
        setUserSeq([]);
        showSequence(newSeq);
    };

    const showSequence = (seq) => {
        setShowing(true);
        seq.forEach((color, i) => {
            setTimeout(() => {
                const btn = document.getElementById(`seq-${color}`);
                if (btn) {
                    btn.style.opacity = "1";
                    btn.style.transform = "scale(1.1)";
                    setTimeout(() => {
                        btn.style.opacity = "0.6";
                        btn.style.transform = "scale(1)";
                    }, 400);
                }
            }, i * 600);
        });
        setTimeout(() => setShowing(false), seq.length * 600 + 200);
    };

    const handleClick = (idx) => {
        if (showing) return;
        const newUserSeq = [...userSeq, idx];
        setUserSeq(newUserSeq);

        if (newUserSeq[newUserSeq.length - 1] !== sequence[newUserSeq.length - 1]) {
            setGameOver(true);
            return;
        }

        if (newUserSeq.length === sequence.length) {
            setTimeout(() => {
                setLevel(level + 1);
                nextRound();
            }, 500);
        }
    };

    if (!started) {
        return (
            <div style={{textAlign:"center",padding:"1rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
                <h4 style={{color:"#facc15",marginBottom:"0.5rem"}}>
                    <i className="fas fa-seedling" style={{marginRight:"6px"}}></i> Sequence Game
                </h4>
                <p style={{fontSize:"0.85rem",marginBottom:"1rem"}}>Memorizza e ripeti la sequenza!</p>
                <button onClick={startGame} style={{background:"linear-gradient(135deg,#facc15,#ca8a04)",border:"none",color:"#000",fontWeight:"700",padding:"0.6rem 1.2rem",borderRadius:"0.5rem",cursor:"pointer"}}>
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    if (gameOver) {
        return (
            <div style={{textAlign:"center",padding:"1.5rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
                <h4 style={{color:"#ef4444",marginBottom:"1rem"}}>
                    <i className="fas fa-times-circle" style={{marginRight:"6px"}}></i> Game Over!
                </h4>
                <p style={{fontSize:"1.5rem",fontWeight:"700",color:"#facc15",marginBottom:"1rem"}}>
                    Livello: {level}
                </p>
                <p style={{fontSize:"0.9rem",marginBottom:"1.5rem"}}>
                    {level >= 10 && "🎉 Memoria incredibile!"}
                    {level >= 5 && level < 10 && "👍 Ottima memoria!"}
                    {level < 5 && "💪 Riprova!"}
                </p>
                <button onClick={startGame} style={{background:"linear-gradient(135deg,#16a34a,#065f46)",border:"none",color:"#fff",fontWeight:"700",padding:"0.6rem 1.2rem",borderRadius:"0.5rem",cursor:"pointer"}}>
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Rigioca
                </button>
            </div>
        );
    }

    return (
        <div style={{textAlign:"center",padding:"1.5rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
            <div style={{marginBottom:"1.5rem",color:"#94a3b8",fontSize:"0.85rem"}}>
                Livello: {level} | Sequenza: {sequence.length}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(2, 1fr)",gap:"1rem",maxWidth:"200px",margin:"0 auto"}}>
                {colors.map((color, i) => (
                    <button key={i} id={`seq-${i}`} onClick={() => handleClick(i)} disabled={showing}
                            style={{aspectRatio:"1",borderRadius:"1rem",border:"none",background:color,cursor:showing?"not-allowed":"pointer",opacity:0.6,transition:"all 0.2s ease",transform:"scale(1)"}}
                    />
                ))}
            </div>
        </div>
    );
}